const stylesMobile = {
  navbarMobile: {
    padding: "clamp(1rem, 5vw, 2rem) clamp(0.5rem, 2vw, 1rem)",
    justifyContent: "space-between",
  },

  hamburger: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    height: "100%",
    fontSize: "clamp(1.5rem, 5vw, 2rem)",
    background: "none",
    border: "none",
    color: "white",
    cursor: "pointer",
    padding: "clamp(0.2rem, 1vw, 0.3rem)",
    marginLeft: "clamp(0.4rem, 2vw, 0.7rem)",
  },

  icon: {
    position: "absolute",
    top: 0,
    left: 0,
    width: "clamp(1.5rem, 8vw, 1.875rem)", // 30px
    height: "clamp(1.5rem, 8vw, 1.875rem)",
    transition: "opacity 0.3s ease, transform 0.3s ease",
  },

  buttonMobile: {
    backgroundColor: "#F68500",
    border: "none",
    color: "#FFF",
    borderRadius: "clamp(1.5rem, 5vw, 30px)",
    padding: "clamp(0.5rem, 2vw, 0.8rem) clamp(1rem, 3vw, 1.5rem)",
    cursor: "pointer",
    fontSize: "clamp(0.9rem, 2.5vw, 1rem)",
    fontWeight: "500",
    letterSpacing: "0.04em",
    transition: "all 0.3s ease",
    marginRight: "clamp(0.5rem, 2vw, 0.7rem)",
  },

  mobileMenu: {
    position: "absolute",
    top: "clamp(4rem, 10vw, 4.8rem)",
    left: "clamp(0.5rem, 3vw, 1rem)",
    width: "clamp(12rem, 50vw, 200px)",
    backgroundColor: "#222",
    borderRadius: "clamp(0.5rem, 2vw, 10px)",
    padding: "clamp(0.3rem, 1vw, 0.5rem) 0",
    boxShadow: "0px 4px 10px rgba(0,0,0,0.5)",
    zIndex: 1000,
  },

  mobileMenuList: {
    listStyle: "none",
    margin: 0,
    padding: 0,
  },

  mobileMenuItem: {
    padding: "clamp(0.8rem, 2.5vw, 1rem)",
    textAlign: "left",
    color: "#FFF",
    fontSize: "clamp(0.8rem, 2vw, 1rem)",
    cursor: "pointer",
    transition: "background 0.3s ease",
  },

  mobileMenuItemHover: {
    backgroundColor: "#333",
  },

  divider: {
    height: "1px",
    backgroundColor: "#444",
    margin: "clamp(0.4rem, 1.2vw, 0.5rem) clamp(0.5rem, 2vw, 1rem)",
  },

  logoImageMobile: {
    width: "clamp(4.5rem, 8vw, 6rem)",
    height: "auto",
    marginLeft: "clamp(3rem, 5vw, 4rem)",
  },
};

export default stylesMobile;
